// extracted by mini-css-extract-plugin
export default {"fixedHeader":"layout_fixedHeader__cQYIc","icon":"layout_icon__VzFLl"};